import { AtSign, Store } from "lucide-react";

import { useDataContext } from "@/app/_context";

const normalizeUrl = (url?: string) => {
  if (!url) return "#"; // Default to "#" if no URL is provided
  return url.startsWith("http://") || url.startsWith("https://")
    ? url
    : `https://${url}`;
};

const BusinessCardTile = ({
  merch,
  socialHref,
}: {
  merch?: boolean;
  socialHref?: string;
}) => {
  const { currentProjectInfo, playerInstance: player } = useDataContext();
  return (
    <a
      href={
        currentProjectInfo && merch
          ? `/store/${currentProjectInfo.authorId}`
          : normalizeUrl(socialHref)
      }
      onClick={() => player?.pause()}
      target={"_blank"}
      className="bg-purple-500 aspect-square hover:bg-purple-600 pointer-events-auto transition-colors rounded-md flex items-center flex-1 h-full w-full justify-center"
    >
      {merch ? <Store /> : <AtSign />}
    </a>
  );
};

export default BusinessCardTile;
